declare const THREE: any;

/**
 *@description
 * Mostly used for
 * getDirectionVectorForRailingInclinedParts
 * to get direction vector
 * @param {any} pos1
 * @param {any} pos2
 * @returns {any}
 * @function
 */
export const getDirectionVectorForRailingInclinedParts = (pos1, pos2) => {
  let direction = pos2.clone().sub(pos1);
  return new THREE.Vector3(-direction.z, 0, direction.x);
};



// WEBPACK FOOTER //
// ./src/app/services/railing/utils/get-direction-vector-for-railing-inclined-parts.ts